import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import { discount, product  } from '../../components/apipath';
import SwitchBox from "../../components/switchBox";
import {switchHelper, dateHelper} from "../../modules/helpers";

function AdmDiscount() {
    const PRODUCT_CATEGORY_MAP = {
        CPA: [1, 2, 3, 4, 5],
        CMA: [6, 7],
        EA: [8, 9],
        美稅: [12, 13, 14, 15, 16, 17],
        CPE:[11, 18],
    };
    const [discountlist, setDiscountlist] = useState([]);
    const [editingDiscount, setEditingDiscount] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [newDiscount, setNewDiscount] = useState(null);
    const [productOptions, setProductOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const { token } = useAuth();
    const [searchTerm, setSearchTerm] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");

    //Read 將後端discount所有折扣資訊導入

    const csvToArr = (csv) =>
    String(csv || "")
        .split(",")
        .map(s => s.trim())
        .filter(Boolean)
        .map(Number);

    const arrToCsv = (arr) =>
    (arr || [])
        .map(Number)
        .filter(Boolean)
        .sort((a,b)=>a-b)
        .join(",");

    const fetchData = async () => {
        try {
            setLoading(true); // 開始加載
            const response = await axios.get(`${discount}`, {headers: {
                Authorization: `Bearer ${token}`,
                token: token
              }});
            setDiscountlist(response.data.data);
            setLoading(false); // 完成加載
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
        }
    };

    const fetchProducts = async () => {
    const res = await axios.get(`${product}` , { headers:{ token }});
    setProductOptions(res.data.data || []);
    };

    useEffect(() => {
    fetchData();
    fetchProducts();
    }, []);


    //Update 設定編輯狀態
    const startEditing = (discount) => {
    setEditingDiscount(discount);
    setUpdatedData({
        ...discount,
        allowProductIds: csvToArr(discount.allow_product_ids),
    });
    };
    const toggleAllowProduct = (pid, checked) => {
    const current = Array.isArray(updatedData.allowProductIds) ? updatedData.allowProductIds : [];
    const next = checked
        ? Array.from(new Set([...current, Number(pid)]))
        : current.filter(x => Number(x) !== Number(pid));

    setUpdatedData({
        ...updatedData,
        discount_id: editingDiscount.discount_id,
        allowProductIds: next,
        // 規則：只要你要限制方案，就固定 1
        limit_to_products: 1,
    });
    };

    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setUpdatedData({
                discount_id: editingDiscount.discount_id,
                ...updatedData,
                [name]: switchHelper(checked),
            });
        } else {
            setUpdatedData({
                discount_id: editingDiscount.discount_id,
                ...updatedData,
                [name]: value,
            });
        }
    };
    //Update 將資訊依照discount_id回傳給後端
    const saveChanges = async () => {
    try {
        const payload = {
        ...updatedData,
        limit_to_products: 1,
        allow_product_ids: arrToCsv(updatedData.allowProductIds),
        };
        delete payload.allowProductIds; // 不送前端用欄位

        await axios.put(`${discount}`, payload, { headers:{ token, Authorization:`Bearer ${token}` } });

        const updatedDiscountList = discountlist.map(d =>
        d.discount_id === editingDiscount.discount_id ? payload : d
        );
        setDiscountlist(updatedDiscountList);
        setEditingDiscount(null);
    } catch (error) {
        console.error('Error updating discount:', error);
    }
    };


    // Create 點擊新增按鈕時的處理函數
    const handleAddNew = () => {
    setNewDiscount({
        name: '',
        discount: '',
        due_date: '',
        memo: '',
        limit_to_products: 1,
        allowProductIds: [],
        status: 1,
        code:'',
    });
    };

    const toggleNewAllowProduct = (pid, checked) => {
    if (!newDiscount) return;
    const current = Array.isArray(newDiscount.allowProductIds) ? newDiscount.allowProductIds : [];
    const next = checked
        ? Array.from(new Set([...current, Number(pid)]))
        : current.filter(x => Number(x) !== Number(pid));

    setNewDiscount({
        ...newDiscount,
        allowProductIds: next,
        limit_to_products: 1,
    });
    };

    // Create 處理新行輸入的變化
    const handleNewInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['checkbox'].includes(type)){
            setNewDiscount({
                ...newDiscount,
                [name]: switchHelper(checked),
            });
        } else {
            setNewDiscount({
                ...newDiscount,
                [name]: value,
            });
        }
    };

    const categorizedProducts = Object.entries(PRODUCT_CATEGORY_MAP).map(
    ([categoryName, ids]) => ({
        categoryName,
        products: ids
        .map(id => {
            const product = productOptions.find(p => Number(p.product_id) === Number(id));
            return product
            ? { product_id: product.product_id, name: product.name }
            : null;
        })
        .filter(Boolean),
    })
    );

    const productNameMap = productOptions.reduce((acc, p) => {
    acc[String(p.product_id)] = p.name;
    return acc;
    }, {});

    const renderAllowedProductsText = (allow_product_ids) => {
    const ids = csvToArr(allow_product_ids);
    if (!ids.length) return "（未設定）";

    return Object.entries(PRODUCT_CATEGORY_MAP)
        .map(([category, categoryIds]) => {
        const matched = ids.filter(id => categoryIds.includes(id));
        if (!matched.length) return null;

        const names = matched
            .map(id => productNameMap[id] || `#${id}`)
            .join("、");

        return `${category}：${names}`;
        })
        .filter(Boolean)
        .join("；");
    };


    // Create 保存新行
    const handleSaveNew = async () => {
        try {
            const payload = {
            ...newDiscount,
            limit_to_products: 1,
            allow_product_ids: arrToCsv(newDiscount.allowProductIds),
            };
            delete payload.allowProductIds;
            // 發送 POST 請求將新折扣數據保存到後端
            const response = await axios.post(`${discount}`, payload, { headers: { Authorization:`Bearer ${token}`, token }});

            if (response.data.status === 200){
                // 新增成功，顯示成功通知
                alert('新增成功！');
                // 將新的折扣數據添加到 discountlist 狀態中
                let newData = { ...payload };
                newData.discount_id = response.data.data[1][0].insertId;
                setDiscountlist([...discountlist, newData]);
                // 重置 newDiscount 狀態
                setNewDiscount(null);
                // 跳轉到另一個頁面（例如折扣列表頁）
                //navigate('/adm/admdiscount'); // 請根據您的路由結構指定正確的路徑
            } else {
                console.error('Error saving new discount:', response.data.msg);
            }
            
        } catch (error) {
            console.error('Error saving new discount:', error);
        }
    };

    const filteredDiscounts = discountlist.filter(d => {
    const keywordMatch =
        d.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        d.code?.toLowerCase().includes(searchTerm.toLowerCase());

    const statusMatch =
        statusFilter === "all"
        ? true
        : String(d.status) === statusFilter;

    return keywordMatch && statusMatch;
    });

    return (
        <>
            <div className="mt100 container-fluid p-5 mt100">
                <div className="text-end mt-2">
                    <button className="btn btn-success me-2" onClick={handleAddNew}>新增</button>
                </div>
                <div className="row mt-2 mb-2">
                <div className="col-md-4">
                    <input
                    type="text"
                    className="form-control"
                    placeholder="搜尋名稱或優惠碼..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className="col-md-3">
                    <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    >
                    <option value="all">全部狀態</option>
                    <option value="1">啟用</option>
                    <option value="0">關閉</option>
                    </select>
                </div>
                </div>

                <div className="mt-2">
                    <table className="table table-striped border table-responsive">
                        <thead>
                            <tr>
                                <th scope="col">名稱</th>
                                <th scope="col">折扣</th>
                                <th scope="col">狀態</th>
                                <th scope="col">優惠碼</th>
                                <th scope="col">可用方案</th>
                                <th scope="col">到期日</th>
                                <th scope="col">備註</th>
                                <th scope="col">修改</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* 渲染新行 */}
                            {newDiscount && (
                                <tr>
                                    <td>
                                        <input
                                            className="border border-primary form-control form-control-sm"
                                            type="text"
                                            name="name"
                                            value={newDiscount.name}
                                            onChange={handleNewInputChange}
                                            required // 必填
                                        />
                                    </td>
                                    <td>
                                        <input
                                            className="border border-primary form-control form-control-sm"
                                            type="number"
                                            name="discount"
                                            value={newDiscount.discount}
                                            onChange={handleNewInputChange}
                                            required // 必填
                                        />
                                    </td>
                                    
                                    <td>
                                        {SwitchBox('status', newDiscount.status, handleNewInputChange)}
                                    </td>
                                    <td>
                                        <input
                                            className="border border-primary form-control form-control-sm"
                                            type="text"
                                            name="code"
                                            value={newDiscount.code}
                                            onChange={handleNewInputChange}
                                            required // 必填
                                        />
                                    </td>
                                    <td>
                                        <div style={{ maxHeight: 180, overflow: "auto" }}>
                                            {categorizedProducts.map(group => (
                                            <div key={group.categoryName} style={{ marginBottom: 8 }}>
                                                <strong>{group.categoryName}</strong>
                                                {group.products.map(p => (
                                                <label key={p.product_id} style={{ display: "block", marginLeft: 12 }}>
                                                    <input
                                                    type="checkbox"
                                                    checked={(newDiscount.allowProductIds || []).includes(Number(p.product_id))}
                                                    onChange={(e) =>
                                                        toggleNewAllowProduct(p.product_id, e.target.checked)
                                                    }
                                                    />
                                                    {" "}
                                                    {p.name}
                                                </label>
                                                ))}
                                            </div>
                                            ))}
                                        </div>
                                    </td>
                                    <td>
                                        <input
                                            className="border border-primary form-control form-control-sm"
                                            type="date"
                                            name="due_date"
                                            value={dateHelper(newDiscount.due_date, 'date')}
                                            onChange={handleNewInputChange}
                                            required // 必填
                                        />
                                    </td>
                                    <td>
                                        <input
                                            className="border border-primary form-control form-control-sm"
                                            type="textarea"
                                            name="memo"
                                            value={newDiscount.memo}
                                            onChange={handleNewInputChange}
                                        />
                                    </td>
                                    <td>
                                        {/* 保存和取消按鈕 */}
                                        <button
                                            className="btn btn-primary m-1"
                                            onClick={handleSaveNew}
                                        >
                                            保存
                                        </button>
                                        <button
                                            className="btn btn-secondary m-1"
                                            onClick={() => setNewDiscount(null)}
                                        >
                                            取消
                                        </button>
                                    </td>
                                </tr>
                            )}
                            {filteredDiscounts.map((discount) => (
                                <tr key={discount.discount_id}>
                                    <td>
                                        {editingDiscount && editingDiscount.discount_id === discount.discount_id ? (
                                            <input
                                                className="border border-primary form-control form-control-sm"
                                                type="text"
                                                name="name"
                                                value={updatedData.name}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            discount.name
                                        )}
                                    </td>
                                    <td>
                                        {editingDiscount && editingDiscount.discount_id === discount.discount_id ? (
                                            <input
                                                className="border border-primary form-control form-control-sm"
                                                type="number"
                                                name="discount"
                                                value={updatedData.discount}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            discount.discount
                                        )}
                                    </td>
                                    
                                    <td>
                                        {editingDiscount && editingDiscount.discount_id === discount.discount_id ? (
                                            SwitchBox('status', updatedData.status, handleInputChange)
                                        ) : (
                                            discount.status === 1 ? "啟用" : "關閉" 
                                        )}
                                    </td>
                                    <td>
                                        {editingDiscount && editingDiscount.discount_id === discount.discount_id ? (
                                            <input
                                                className="border border-primary form-control form-control-sm"
                                                type="text"
                                                name="code"
                                                value={updatedData.code}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            discount.code
                                        )}
                                    </td>
                                    <td>
                                        {editingDiscount && editingDiscount.discount_id === discount.discount_id ? (
                                            <div style={{ maxHeight: 180, overflow: "auto" }}>
                                            {Object.entries(PRODUCT_CATEGORY_MAP).map(([category, ids]) => (
                                                <div key={category} style={{ marginBottom: 8 }}>
                                                <strong>{category}</strong>
                                                {ids.map((id) => {
                                                    const name = productNameMap[Number(id)];
                                                    // 沒抓到產品資料就不顯示（避免出現空白）
                                                    if (!name) return null;

                                                    return (
                                                    <label key={id} style={{ display: "block", marginLeft: 12 }}>
                                                        <input
                                                        type="checkbox"
                                                        checked={(updatedData.allowProductIds || []).includes(Number(id))}
                                                        onChange={(e) => toggleAllowProduct(id, e.target.checked)}
                                                        />
                                                        {" "}
                                                        {name}
                                                    </label>
                                                    );
                                                })}
                                                </div>
                                            ))}
                                            </div>
                                        ) : (
                                            <div style={{ whiteSpace: "normal" }}>
                                            {renderAllowedProductsText(discount.allow_product_ids)}
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {editingDiscount && editingDiscount.discount_id === discount.discount_id ? (
                                            <input
                                                className="border border-primary form-control form-control-sm"
                                                type="date"
                                                name="due_date"
                                                value={dateHelper(updatedData.due_date, 'date')}
                                                onChange={handleInputChange}
                                                required // 必填
                                            />
                                        ) : (
                                            dateHelper(discount.due_date, 'date')
                                        )}
                                    </td>
                                    <td>
                                        {editingDiscount && editingDiscount.discount_id === discount.discount_id ? (
                                            <input
                                                className="border border-primary form-control form-control-sm"
                                                type="textarea"
                                                name="memo"
                                                value={updatedData.memo}
                                                onChange={handleInputChange}
                                            />
                                        ) : (
                                            discount.memo
                                        )}
                                    </td>
                                    <td>
                                        {editingDiscount && editingDiscount.discount_id === discount.discount_id ? (
                                            <>
                                                <button
                                                    className="btn btn-primary m-1"
                                                    onClick={saveChanges}
                                                >
                                                    保存
                                                </button>
                                                <button
                                                    className="btn btn-secondary m-1"
                                                    onClick={() => setEditingDiscount(null)}
                                                >
                                                    取消
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                className="btn btn-primary m-1"
                                                onClick={() => startEditing(discount)}
                                            >
                                                編輯
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
export default AdmDiscount;